import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';
import { AppLibraryBlock } from '../../_blocks/AppLibrary';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type AppLibraryWidget = ContextWidget<AppLibraryBlock, WidgetType.applibrary | WidgetType.applibraryglobal>;

export function AppLibraryWidget({ elementType, ...props }: AppLibraryWidget) {
  const { t } = useTranslation(Namespace.AppLibrary);
  const title = elementType === WidgetType.applibraryglobal ? t('widgetTitle.global') : t('widgetTitle.withinPage');

  return <DefaultContextWidget elementType={elementType} icon={Icons.APP_LIBRARY} title={title} {...props} />;
}
